export default {
    CustomerList: {
        ChooseCustomer: 'Kunde auswählen',
    },

    Customer: {
        SafesOnline: 'SafePoints online',
        CurrentBalance: 'Aktueller Stand',
        DailySales: 'Tägliche Umsätze',
        ActiveWarnings: 'Aktive Warnungen',
        Of: 'Von',
        In: 'In',
        Branches: 'Standorte'
    },

    Branch: {
        ExportTransactions: "Transaktionen exportieren",
        ManageOperators: "Benutzer verwalten",
        ShowOnMap: "Auf der Karte anzeigen",
        CurrentBalance: "Aktueller Stand",
        DailySales: 'Tägliche Umsätze',
        MainCurrency: 'Standard Währung',
        TransactionDays: 'Tranaktionstage'
    },

    BranchList: {
        Name: 'Name',
        Status: 'Status',
        BalanceAmount: 'Stand',
        BalanceCurrency: 'Währung',
        LastBalance: 'Letzter Stand',
        Branches: 'Standorte',
    },

    BranchListFilter: {
        Branches: 'Standorte',
        SearchCriteria: 'Finde Standort...',
    },


    Chart: {
        Sales: 'Umsätze',
        Pickup: 'Abholung',
        Balance: 'Stand',
        Difference: 'Differenz',
        Confirmed: 'Gezählt',
        SalesBalancesAndPickups: 'Umsätze, Bestände & Abholungen',
        NoDataAvailable: 'Keine Daten vorhanden',
        SafebagBalance: 'Bestand SafeBag',
        RecyclableBalance: 'Bestand recyclierbar',
        ManualDepositBalance: 'Bestand manuelle Einzahlungen',
        OverflowBalance: 'Bestand Überlauf'
    },

    ChartDenominations: {
        Deposited: 'Eingezahlt',
        Recyclable: 'Recyclierbar',
        Denominations: 'Denominationen',
        NoDataAvailable: 'Keine Daten vorhanden'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Verarbeitete Umsätze',
        UnprocessedSales: 'Nicht verarbeitete Umsätze',
        SalesOut: 'Umsätze ausgehend',
        SalesPerHour: 'Umsätze pro Stunde'
    },

    CustomerHeader: {
        ShowOnMap: 'Auf der Karte anzeigen',
        Branches: 'Standorte',
        Branch: 'Standort',
        ExportTransactions: 'Transaktionen',
    },

    DeviceStatus: {
        AllOk: 'Alles OK',
    },

    DeviceStatusList: {
        Safes: 'SafePoints',
    },

    ExportForm: {
        ExportTransactions: 'Transaktionen exportieren',
        Cancel: 'Abbrechen',
        Export: 'Exportieren',
        FromDate: 'Datum von',
        Time: 'Zeit',
        EndDate: 'Datum bis'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Passwort vergessen?',
        ForgotText: 'Bitte E-Mail-Adresse untenstehend eingeben und auf Button klicken. Sie werden eine E-Mail mit Instruktionen erhalten.',
        LoginLink: 'Zurück zu Login',
        EmailAddress: 'E-Mail-Adresse',
        Submit: 'E-Mail senden',
        ErrorMessage: 'Ihre Anfrage konnte nicht an den Server übermittelt werden'
    },

    LoginPage: {
        LoginHeader: 'Willkommen',
        LoginText: 'Loggen Sie sich mit Ihrer E-Mail-Adresse und Passwort ein',
        LoginForgot: 'Haben Sie Ihr Passwort vergessen?',
        Username: 'E-Mail Adresse',
        Password: 'Passwort',
        Login: 'Login'
    },

    ResetPasswordPage: {
        ResetHeader: 'Passwort zurücksetzen',
        ResetText: 'Geben Sie Ihr neues Passwort ein.'
    },

    Drawer: {
        Dashboard: 'Übersicht',
        SwitchCustomer: 'Kunde wechseln',
        MyProfile: 'Mein Profil',
        Report: 'Berichte',
        Logout: 'Abmelden'
    },

    OperatorForm: {
        UserId: 'Benutzer-ID',
        FirstName: 'Vorname',
        LastName: 'Nachname',
        Pin: 'PIN',
        Save: 'Speichern',
        Delete: 'Löschen',
        Operator: 'Benutzer'
    },

    OperatorList: {
        AddOperator: 'Benutzer hinzufügen',
        Operators: 'Benutzer',
        Name: 'Name'
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Name',
        Language: 'Sprache',
        Password: 'Passwort',
        ConfirmPassword: 'Passwort bestätigen',
        Update: 'Ändern'
    },

    ResetPasswordForm: {
        NewPassword: 'Neues Passwort',
        ConfirmPassword: 'Password bestätigen',
        Submit: 'Abschicken'
    },

    InviteUserForm: {
        InviteHeader: 'Benutzer eingeladen',
        InviteText: 'Bitte füllen Sie Ihre Angaben aus und speichern Sie diese, um sich anschliessend einzuloggen.',
        Language: 'Sprache',
        NewPassword: 'Neues Passwort',
        ConfirmPassword: 'Passwort bestätigen',
        Submit: 'Speichern'
    },

    TransactionList: {
        Type: 'Typ',
        Operator: 'Benutzer',
        When: 'Wann',
        Amount: 'Wert',
        Currency: 'Währung',
        Transactions: 'Transaktionen',
        Device: 'SafePoint',
        SalesDay: 'Umsatz Tag',
        HoverDeposit: 'Umsätze IN',
        HoverSalesIn: 'Umsätze IN',
        HoverSalesOut: 'Umsätze OUT',
        HoverManualDeposit: 'Manuelle Einzahlungen',
        HoverCollection: 'Leerungen',
        HoverCollectionNotes: 'Leerungen von Noten',
        HoverCollectionCoins: 'Leerungen von Münzen',
        HoverCollectionEnvelope: 'Leerungen von manuellen Einzahlungen',
        HoverCollectionOK: 'Leerung bestätigt',
        HoverCollectionNotesOK: 'Leerung von Noten bestätigt',
        HoverCollectionCoinsOK: 'Leerung von Münzen bestätigt',
        HoverCollectionEnvelopeOK: 'Leerung von manuellen Einzahlungen bestätigt',
        HoverCollectionNOK: 'Leerungsdifferenzen',
        HoverCollectionNotesNOK: 'Differnezen bei Leerung von Noten',
        HoverCollectionCoinsNOK: 'Differenzen bei Leerung von Münzen',
        HoverCollectionEnvelopeNOK: 'Differenzen bei manuellen Einzahlungen',
        HoverDrain: 'Leerungen',
        HoverRefill: 'Befüllungen',
        HoverExchange: 'Wechsel',
        HoverExchangeIn: 'Wechsel IN',
        HoverExchangeOut: 'Wechsel OUT',
        HoverCounterfeit: 'Falschgeld',
        HoverInternal: 'Interne Transaktion',
        HoverNOP: 'Keine Verarbeitung'
    },

    TransactionDayList: {
        Date: "Datum",
        Sales: "Umsätze",
        Pickup: "Leerungen",
        Balance: "Bestände",
        TransactionDays: "Transaktionstage"
    },

    TransactionDay: {
        Date: "Datum",
        Sales: "Umsätze",
        Pickup: "Leerungen",
        Balance: "Bestände",
        TransactionDays: "Transaktionstage",
        ExportTransactions: "Transaktionen"
    },

    TransactionDatePicker: {
        Date: 'Datum'
    },

    ReportForm: {
        Title: "Berichte",
        Enabled: 'Aktivieren von Berichten',
        ReportSaved: 'Bericht gespeichert',
        NextExecution: 'Nächste Berichtsauslösung: ',
        Reports: 'Berichte',
        Report: 'Bericht',
        ReportTRANSACTION: 'Transaktionsbericht',
        ReportBALANCE: 'Umsatzbericht',
        ReportOPERATOR: 'Benutzerbericht',
        ReportTypeCSV: 'CSV',
        ReportTypeEXCEL: 'Excel',
        ReportTypePDF: 'PDF',
        Execution: 'Ausführung',
        ExecutionTypeMonth: '1x pro Monat',
        ExecutionTypeWeekDay: 'Wochentage',
        ExecutionDay: 'Kalendertag',
        ExecutionTime: 'Ausführungszeitpunkt',
        ExecutionTimePattern: '00:00',
        ExecutionWeekDayMONDAY: 'Montag',
        ExecutionWeekDayTUESDAY: 'Dienstag',
        ExecutionWeekDayWEDNESDAY: 'Mittwoch',
        ExecutionWeekDayTHURSDAY: 'Donnerstag',
        ExecutionWeekDayFRIDAY: 'Freitag',
        ExecutionWeekDaySATURDAY: 'Samstag',
        ExecutionWeekDaySUNDAY: 'Sonntag',
        Content: 'Inhalt',
        ContentTypeSinceLast: 'Alles seit letztem Bericht',
        ContentTypeRelative: 'Zeitraum',
        ContentRelativeType: 'Verganenheit: ',
        ContentRelativeTypeDAY: 'Tage',
        ContentRelativeTypeWEEK: 'Wochen',
        ContentRelativeTypeMONTH: 'Monate',
        ErrorFieldRequired: 'Felder benötigt!',
        ErrorSelectAtLeastOneDay: 'Wählen Sie mindestens einen Tag.',
        ErrorFormat: 'Es sollte in diesem Format sein: HH:MM',
        ErrorEnableAtLeastOneReport: 'Aktivieren Sie mindestens einen Bericht',
        Update: 'Speichern'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/de.js